// @flow
import React from 'react';
import type { SocialContent } from 'types/SocialContent';
import { getTimeDifference } from 'utils/dateUtils';
import Label from 'components/fragments/text/Label';

export type StateProps = {
  twitter_lien: string
};

type Props = {
  content: SocialContent,
  transparent?: boolean,
  onClick: Function
} & StateProps;

const TwitterCard = (props: Props) => {
  const { backgroundImage, description, likes, share, id } = props.content;
  const date = props.content.date instanceof Date ? props.content.date : new Date(props.content.date);

  return (
    <a
      href={`${props.twitter_lien}/status/${id}`}
      onClick={props.onClick}
      className="box card card--social"
      title="Voir ce contenu sur X"
      style={{ opacity: props.transparent ? 0.3 : 1 }}
      target="_blank"
      rel="noopener noreferrer">
      {backgroundImage && (
        <div className="card__thumbnail" style={{ backgroundImage: `url(${backgroundImage})` }} />
      )}
      <div className="card__body">
        <p className="card__desc ft-secondary" dangerouslySetInnerHTML={{ __html: description }} />
      </div>
      <div className="card__footer ft-h6">
        <div className="card__stat">
          <span>
            <i className="icon icon-rt" />
            {share}
          </span>
          <span>
            <i className="icon icon-like-insta" />
            {likes}
          </span>
        </div>
        <span className="ft-up">{`${getTimeDifference(new Date(), date)}`}</span>
      </div>
      <div className="card__social">
        <Label isBlue icon="icon-twitter" />
      </div>
    </a>
  );
};

export default TwitterCard;
